<!-- 选择服务内容面板 -->
<template>
    <panel-down :panelTitle="'选择服务内容'" :isShowCont="isShowCont"
    @surePanel="surePanel" @closePanel="closePanel">
        <ul class="pub-servicetype-wrap">
            <li class="servicetype-item" v-for="(item,index) in list" :key="item.SubCategoryId" 
            :class="{'selected': item.Selected}" @click="chooseItem(item.SubCategoryId)">
                <div class="item-show">
                    <img :src="require('../../assets/images/release/search_subcat_item_0'+ (index+1) +'_show.jpg')">
                    <span class="mask-bar"></span>
                </div>
                <div class="item-title">
                    <img :src="require('../../assets/images/release/search_subcat_item_0'+ (index+1) +'_title.png')">
                </div>
            </li>
        </ul>
    </panel-down>
</template>
<script>
export default {
    props: {
        curServicetype: {
            type: Array
        },
    },
	data () {
		return {
            isShowCont: true,
            list: [
                {
                    SubCategoryId: 1,
                    SubCategoryName: "做饭",
                    Selected: false
                },
                {
                    SubCategoryId: 2,
                    SubCategoryName: "做家务",
                    Selected: false
                },
                {
                    SubCategoryId: 32,
                    SubCategoryName: "照顾母婴",
                    Selected: false
                },
                {
                    SubCategoryId: 9,
                    SubCategoryName: "照顾孩子",
                    Selected: false
                },
                {
                    SubCategoryId: 4,
                    SubCategoryName: "照顾自理老人",
                    Selected: false
                },
                {
                    SubCategoryId: 5,
                    SubCategoryName: "照顾不能自理老人",
                    Selected: false
                },
                {
                    SubCategoryId: 36,
                    SubCategoryName: "照顾病人",
                    Selected: false
                },
                {
                    SubCategoryId: 8,
                    SubCategoryName: "饲养宠物",
                    Selected: false
                },
                {
                    SubCategoryId: 99,
                    SubCategoryName: "其它",
                    Selected: false
                },
            ],
		}
    },
    mounted(){
        this.initSelected();
    },
	methods: {
        //初始化选中
        initSelected(){
            let self = this;
            this.list.map(item => {
                if(self.curServicetype && self.curServicetype.length>0){
                    for(let i=0; i<self.curServicetype.length; i++){
                        if (self.curServicetype[i].id == item.SubCategoryId) {
                            item.Selected = true;
                            break;
                        } else {
                            item.Selected = false;
                        }
                    }
                } else {
                    item.Selected = false;
                }
            });
        },
        //选择服务
        chooseItem(itemId) {
            this.list.map(item => {
                if (item.SubCategoryId == itemId) {
                    item.Selected = !item.Selected;
                }
            });
        },
        //确定
        surePanel(){
            let selectedList = [];
            this.list.map(item => {
                if (item.Selected) {
                    selectedList.push(item);
                }
            });
            this.$emit("surePanel",selectedList);
            this.closePanel();
        },
        //取消
        closePanel() {
            this.isShowCont = false;
            let delayClosePanel = setTimeout(() => {
                this.$emit("closePanel");
            }, 500);
        },
	}
}
</script>
<style>
.pub-servicetype-wrap{
    width: 85%;
    margin: 0.6rem auto 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
}
.servicetype-item {
    flex: 0 0 auto;
    width: 31.2%;
    margin-bottom: 0.7rem;
    position: relative;
    transition: all 0.5s ease;
}

.servicetype-item-show {
    width: 100%;
    position: relative;
}

.servicetype-mask-bar {
    width: 100%;
    height: 0.15rem;
    display: block;
    background-color: #666666;
    opacity: 0.2;
    position: absolute;
    left: 0;
    bottom: 0;
    transition: all 0.5s ease;
}

.servicetype-item-title {
    width: 100%;
    background-color: #e6e6e7;
    transition: all 0.5s ease;
}

.servicetype-item.selected .mask-bar {
    background-color: #edaf33;
}

.servicetype-item.selected .item-title {
    background-color: #fbefd6;
    transition: all 0.5s ease;
}

.servicetype-item:before,
.servicetype-item:after {
    content: "";
    width: 100%;
    display: block;
    background-color: #ffffff;
    position: absolute;
    transition: all 0.5s ease;
}

.servicetype-item:before {
    height: 0.05rem;
    top: -0.05rem;
}

.servicetype-item:after {
    height: 0.12rem;
    bottom: -0.12rem;
}

.servicetype-item.selected:before,
.servicetype-item.selected:after {
    background-color: #edaf33;
    transition: all 0.5s ease;
}
</style>


// WEBPACK FOOTER //
// src/shared/components/job/servicetype-panel.vue